<template>
    <JobFormLayout :initialized="initialized && !saving" :error-message="errorMessage">

        <el-row style="margin-bottom:30px">
            <el-col :span="8">
                <h1 v-if="isEditForm" style="margin-bottom:10px">
                    Edit Job <span v-if="jobIsGenerated">( Feed Generated )</span>
                </h1>
                <h1 v-else style="margin-bottom:10px">New Job</h1>
            </el-col>

            <el-col :span="16">
                <el-button type="danger"
                           @click="submitFormCheck(jobIsGenerated)"
                           :disabled="saving"
                           class="is-aligned-right">
                    <i class="fa fa-save" aria-hidden="true"></i>
                    <template v-if="isEditForm">Save Changes</template>
                    <template v-else>Create Job</template>
                </el-button>

                <el-button v-if="isTrUser && isEditForm"
                           @click="beforeDuplicate"
                           type="danger"
                           class="is-aligned-right"
                           style="margin-right:10px">
                    <span class="fa fa-copy" aria-hidden="true"></span> Duplicate
                </el-button>

                <el-button v-if="isTrUser && isEditForm"
                           @click="openEditLP"
                           type="danger"
                           class="is-aligned-right">
                    <i class="fas fa-external-link-alt"></i>
                    Landing Page Editor
                </el-button>
            </el-col>
        </el-row>

        <el-dialog
            :visible.sync="duplicateJobDialog.isVisible"
            width="30%"
            :close-on-click-modal="false"
            :before-close="closeDuplicateJobDialog">
            <div class="row" style="margin-bottom: 10px;">
                <div class="col-sm-12">
                    This job has own delivery assigned.<br />
                    Do you want to duplicate it as well?
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    Job ID: {{ job.id }}<br />
                    Integration: {{ job.deliveryAgent }}
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="makeDuplicate(true)">Yes</el-button>
                <el-button type="primary" @click="makeDuplicate(false)">No</el-button>
            </span>
        </el-dialog>


        <el-row style="margin-bottom:30px">
            <el-col :md="3" :lg="3" style="padding-bottom:5px">
              <el-button type="primary"
                         :disabled="!pagination.prevId"
                         @click="gotoJob(pagination.prevId)"
                         size="small"><i class="fa fa-angle-left"></i></el-button>
              <span style="font-size:14px;padding:0 5px;">{{ pagination.actualJob }} / {{ pagination.totalJobs }}</span>
              <el-button type="primary"
                         :disabled="!pagination.nextId"
                         @click="gotoJob(pagination.nextId)"
                         size="small"><i class="fa fa-angle-right"></i></el-button>
            </el-col>
            <el-col :md="9" :lg="9" style="padding-bottom:5px">
                <el-tag v-if="filter">{{ filterHumanReadable }}</el-tag>
            </el-col>
        </el-row>

        <el-form label-position="top" :model="formValues" ref="jobForm" :rules="formRules">
            <el-row>
                <el-col :span="24">
                    <JobFormTitles @initialized="initialize"
                                   @error="error"
                                   :is-tr-user="isTrUser"
                                   :job-id="job.id"
                                   v-model="formValues.titles"/>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <JobFormMap v-if="initialized"
                                :area-id="formValues.areaId"
                                :google-api-key="googleApiKey"
                                :maps-url="mapsUrl"
                                :is-tr-user="isTrUser"
                                :has-error="mapsHasError"/>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <JobFormSpecs @error="error"
                                  v-if="initialized"
                                  :job-id="job.id"
                                  :employer-id="employer.id"
                                  v-model="formValues.specs"/>
                </el-col>
            </el-row>
        </el-form>

        <el-row style="margin-top:20px">
            <el-col :span="24">
                <el-button type="danger"
                           @click="submitFormCheck(jobIsGenerated)"
                           :disabled="saving">
                    <i class="fa fa-save" aria-hidden="true"></i>
                    <template v-if="isEditForm">Save Changes</template>
                    <template v-else>Create Job</template>
                </el-button>
            </el-col>
        </el-row>
    </JobFormLayout>
</template>

<script>
import JobFormLayout from './job-form-components/job-form-layout.vue';
import JobFormTitles from './job-form-components/job-form-titles.vue';
import JobFormMap from './../../../maps/vue/map.vue';
import JobFormSpecs from './job-form-components/job-form-specs';
// import {validateZipCodes} from '../../../maps/vue/helpers/validators';

const baseFormRules = {
        'titles.title': [
            { required: true, message: 'Please input some title.', trigger: 'change' },
            { max: 120, message: 'Length must be below 120 characters.', trigger: 'blur' },
        ],
    };

    const adminFormRules = {
        'titles.adminDescription': [
            { max: 255, message: 'Length must be below 255 characters.', trigger: 'blur' },
        ],
        // TODO: areaId empty
        // 'zipCodes': [
        //     { validator: validateZipCodes, trigger: 'blur' },
        // ],
        'specs.delivery.info.cdlMinXp': [
            { required: true, message: 'Select min required CDL experience.', trigger: 'change' },
        ],
        'specs.delivery.info.directAppMethod': [
            { required: true, message: 'Select job application method.', trigger: 'change' },
        ],
        'specs.pricing.campaign': [
            { type: 'array', required: true, message: 'Please select at least one campaign', trigger: 'blur' },
        ],
    };

    export default {
        components: { JobFormLayout, JobFormTitles, JobFormMap, JobFormSpecs },
        props: {
            // could be null, used only for mounted method, otherwise use employerId
            employerId: { type: Number, required: true },
            jobId: { type: Number, required: true },
            isTrUser: { type: Boolean, required: true },
            googleApiKey: { type: String, required: true },
            mapsUrl: { type: String, required: true },
        },
        data() {
            return {
                isInitialized: { base: false, titles: false, areaId: false },
                errorMessage: '',
                employer: { id: !this.employerId ? 0 : this.employerId },
                mapsHasError: false, // TODO: remove
                job: {
                    id: !this.jobId ? 0 : this.jobId,
                    isGenerated: null,
                },
                pagination : {
                    actualJob : null,
                    totalJobs : null,
                    prevId : null,
                    nextId : null,
                },
                isDuplicate: false,
                togglingPromotion: false,
                formValues: { titles: {}, areaId: null, specs: {} },
                formRules: _.merge(baseFormRules, (this.isTrUser ? adminFormRules : {})),
                saving: false,
                duplicateJobDialog: {
                    isVisible: false,
                },
                duplicateJobDelivery: false,
            };
        },
        computed: {
            initialized() { return this.isInitialized.base && this.isInitialized.titles && this.isInitialized.areaId; },
            isEditForm() { return this.job.id !== 0 && !this.isDuplicate; },
            jobIsGenerated() { return this.job.isGenerated !== null && parseInt(this.job.isGenerated) !== 0; },
            filter() {
                const params = this.getUrlParams(document.location.href);
                if(params && params.filter)
                {
                    try { return JSON.parse(atob(params.filter)); } catch(e) {}
                }

                return null;
            },
            filterHumanReadable() {
                const f = this.filter;
                if(!f) return "";

                let ft = "filtering jobs according to the following conditions: ";//"filtering jobs by: ";

                let ft_pieces = [];
                if(f.product) ft_pieces.push("Product is "+this.capitalize(f.product));
                if(f.activity) ft_pieces.push("Activity is "+this.capitalize(f.activity));

                if(f.filterData)
                {
                    let fd = f.filterData;
                    if(fd.title) ft_pieces.push("Title contains '"+fd.title+"'");
                    if(fd.id) ft_pieces.push('Job.ID is (' + fd.id.split(',').join(' or ') + ')');
                    if(fd.campaign && fd.campaign.length === 1) ft_pieces.push('Campaign.ID is ' + fd.campaign[0]);
                    if(fd.campaign && fd.campaign.length > 1) ft_pieces.push('Campaign.ID is (' + fd.campaign.join(' or ') + ')');
                    if(fd.states && fd.states.length === 1) ft_pieces.push("State is "+fd.states[0]);
                    if(fd.states && fd.states.length>1) ft_pieces.push("State is ("+fd.states.join(' or ')+")");

                    for(let cat in fd)
                    {
                        if(['title','id','campaign','states'].includes(cat)) continue;

                        let value = fd[cat];
                        let catTitle = cat.split('_').reduce((prev, curr)=> prev+' '+this.capitalize(curr),'').trim();
                        if(value) ft_pieces.push(catTitle+" is ON");
                    }
                }

                let finalText = ft+ft_pieces.join(" and ");
                return finalText.trim();
            }
        },
        mounted() {
            // every time this component is mounted, we want employer's ID
            // can get it from JOB, but if it's null -> need to throw error
            if (!this.job.id && !this.employer.id) {
                this.error('Internal error, please contact administrator.');
                this.$set(this.isInitialized, 'base', true);
            } else if (this.job.id > 0) {
                this.loadFormBaseData();
            } else {
                this.startAreaSession();
                this.$set(this.isInitialized, 'base', true);
            }
        },
        methods: {
            initialize(type) { this.$set(this.isInitialized, type, true); },
            gotoJob(jobId) {
                let url = window.location.href.replace(this.job.id, jobId);
                this.$set(this.isInitialized, 'base', false);
                window.location.href = url;
                // this.job.id = jobId;
                // this.$set(this.isInitialized, 'base', false);
                // this.loadFormBaseData().then(()=>{
                //     history.pushState(history.state, document.title, url);
                // });
            },
            capitalize(s) {
                if (typeof s !== 'string') return ''
                return s.charAt(0).toUpperCase() + s.slice(1);
            },
            loadFormBaseData() {
                const params = this.getUrlParams(document.location.href);
                let getUrl = url(`/admin/jobs/load-form-base-data?jobId=${this.job.id}&employerId=${this.employer.id}`);
                if(params && params.filter) getUrl += `&filter=${params.filter}`;

                axios.get(getUrl)
                     .then(response => {
                         if (response.status !== 200) {
                           throw new Error('Request could not be processed, please contact administrator.');
                         }

                         if (typeof response.data.employerId !== 'undefined') {
                           this.$set(this.employer, 'id', parseInt(response.data.employerId));
                         }

                         if (typeof response.data.job !== 'undefined') {
                           this.job = _.merge(this.job, response.data.job);
                         }

                         if (typeof response.data.pagination !== 'undefined') {
                           this.pagination = _.merge(this.pagination, response.data.pagination);
                         }

                        this.startAreaSession(this.job.id);
                     })
                     .catch(err => { this.error(err.message); })
                     .finally(() => { this.$set(this.isInitialized, 'base', true); });
            },
            startAreaSession(jobId = null) {
                this.$set(this.isInitialized, 'areaId', false);

                axios.post(this.url(`admin/area/start-session`), {
                    job_id: jobId
                }).then(response => {
                    this.formValues.areaId = response.data.id;

                    this.$set(this.isInitialized, 'areaId', true);
                });
            },
            beforeDuplicate() {
                if (this.job.id && this.job.deliveryAgent) {
                    this.duplicateJobDialog.isVisible = true;
                } else {
                    this.makeDuplicate();
                }
            },
            makeDuplicate(duplicateJobDelivery = false) {
                this.isDuplicate = true;
                this.duplicateJobDelivery = duplicateJobDelivery;
                this.$set(this.job, 'isGenerated', null);
                this.$set(this.formValues.titles, 'adminDescription', 'Copy of ' + this.job.id + ' - ' + this.formValues.titles.title);
                this.closeDuplicateJobDialog();
            },
            getUrlParams (url) {
                let params = {};
                let parser = document.createElement('a');
                parser.href = url;
                let query = parser.search.substring(1);
                let vars = query.split('&');
                for (let i = 0; i < vars.length; i++) {
                    let pair = vars[i].split('=');
                    params[pair[0]] = decodeURIComponent(pair[1]);
                }
                return params;
            },
            error(message) { this.errorMessage = message; },
            openEditLP() {
                window.open(url(`admin/glp/${this.jobId}/editor`));
            },
            submitFormCheck(warning) {
                this.$refs['jobForm'].validate((valid, errors) => {

                    const alerts = [];

                    // some job categories are required
                    // let's check if at least one of each is checked (except Specialization, we don't need that)
                    let catNames = Object.keys(this.formValues.specs.delivery.filters);
                    catNames.forEach((catName, i) => {
                        if (catName === 'Specialization') return;

                        let sum = 0;
                        this.formValues.specs.delivery.filters[catName].forEach((spec, i) => {
                            sum += spec.checked;
                            console.log(spec);
                        });

                        if (sum === 0) {
                            valid = false;
                            alerts.push(this.$createElement('li', null, `No option selected for "${catName}"`));
                        }
                    });

                    if (!valid) {
                        for(let index in errors) {
                            if (!errors.hasOwnProperty(index)) continue;

                            errors[index].forEach((errObj) => {
                                alerts.push(this.$createElement('li', null, `${errObj.message}`));
                            });
                        }

                        this.$alert(this.$createElement('div', { style: 'color: #f56c6c' }, [
                            this.$createElement('p', null, 'There are some errors in the form:'),
                            this.$createElement('ul', null, alerts),
                        ]), 'Form contains errors')
                            .then(() => {})
                            .catch(() => {});
                    } else if (warning) {
                        this.$confirm('You are editing a feed generated job. Your changes may be overwritten.',
                            'Attention', {
                                confirmButtonText: 'Save anyway',
                                cancelButtonText: 'Cancel'
                            })
                            .then(() => {
                                this.submitForm();
                            })
                            .catch(() => {});
                    } else {
                        this.submitForm();
                    }
                });
            },
            submitForm() {
                this.saving = true;
                axios.post(url(`admin/jobs/store`),
                    _.merge(this.formValues,
                        { 
                            jobId: this.job.id, 
                            employerId: this.employer.id, 
                            isDuplicate: this.isDuplicate, 
                            duplicateJobDelivery: this.duplicateJobDelivery,
                            originalJobId: this.jobId
                        }))
                     .then(response => {
                         if (response.status !== 200 || typeof response.data.redirectUrl === 'undefined') {
                             throw Error('Invalid server response');
                         }

                         if(this.job.id > 0 && !this.isDuplicate) {
                            this.startAreaSession(this.job.id);

                             this.$confirm(
                                 'Yes, job was saved! We will redirect you to the list of the jobs or by canceling you will stay on current page.',
                                 'Job saved', {
                                     confirmButtonText: 'Return to Job List',
                                     cancelButtonText: 'Save & Continue'
                                 })
                                 .then(() => {
                                     window.location.href = response.data.redirectUrl;
                                 })
                                 .catch(() => {
                                     this.saving = false;
                                 });
                         } else {
                             window.location.href = response.data.redirectUrl;
                         }
                     })
                     .catch(err => {
                        if (err.message === 'Request failed with status code 590') {
                            this.saving = false;
                        } else {
                            this.$message.error(`Job could not be saved due to: ${err.message}`);
                        }
                     });
            },
            closeDuplicateJobDialog() {
                this.duplicateJobDialog.isVisible = false;
            },
        },
    };
</script>

<style scoped>
    h1 > span {
        color: #e64e42;
        font-style: italic;
        font-weight: normal;
        font-size: 14px;
    }
</style>
